import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Breadcrumb from '../../../../shared/breadcrumb/Breadcrumb';
import Items from './Items';
import { Tabs } from '../../../../components';

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedTab: 0,
    };
  }

  changeSelectedTab = (/* { index } */) => {
    // this.setState({ selectedTab: index });
  };

  render() {
    const { match } = this.props;

    return (
      <div>
        <Breadcrumb crumb="Brindes" description="Gerencie os pedidos de brindes." />
        <section className="content-wrapper">
          <Tabs
            sections={[
              { title: 'Todos', path: `${match.url}/todos` },
              { title: 'Pendente', path: `${match.url}/pendentes` },
              { title: 'Preparação', path: `${match.url}/preparacao` },
              { title: 'Pronto p/ Entrega', path: `${match.url}/prontos` },
              { title: 'Entregue', path: `${match.url}/entregue` },
              { title: 'Cancelado', path: `${match.url}/cancelado` },
            ]}
          />
          <Route
            path={`${match.url}/todos`}
            component={props => (
              <div className="screen-table-gifts">
                <Items
                  {...props}
                  defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&cancelados="
                />
              </div>

            )}
          />
          <Route
            path={`${match.url}/pendentes`}
            component={props => (
              <div className="screen-table-gifts">
                <Items
                  {...props}
                  defaultFilters="pendente=true&preparacao=&prontoEntrega=&entregue=&cancelados="
                />
              </div>

            )}
          />
          <Route
            path={`${match.url}/preparacao`}
            component={props => (
              <div className="screen-table-gifts">
                <Items
                  {...props}
                  defaultFilters="pendente=&preparacao=true&prontoEntrega=&entregue=&cancelados="
                />
              </div>

            )}
          />
          <Route
            path={`${match.url}/prontos`}
            component={props => (
              <div className="screen-table-gifts--prontos">
                <Items
                  {...props}
                  defaultFilters="pendente=&preparacao=&prontoEntrega=true&entregue=&cancelados="
                />
              </div>

            )}
          />
          <Route
            path={`${match.url}/entregue`}
            component={props => (
              <div className="screen-table-gifts">
                <Items
                  {...props}
                  defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=true&cancelados="
                />
              </div>

            )}
          />
          <Route
            path={`${match.url}/cancelado`}
            component={props => (
              <div className="screen-table-gifts">
                <Items
                  {...props}
                  defaultFilters="pendente=&preparacao=&prontoEntrega=&entregue=&cancelados=true"
                />
              </div>
            )}
          />
        </section>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Trades/Gifts/List.js